import { entities } from "sb-bff-integration";
export const isNonRunner = (selection) => (selection === null || selection === void 0 ? void 0 : selection.status) === entities.SelectionStatus.NonRunner
    ? 1
    : 0;
//# sourceMappingURL=isNonRunner.js.map